/**
 * @fileoverview TanStack Query クライアント設定
 * @description サーバー状態管理のためのQueryClient設定
 * @see https://tanstack.com/query/latest/docs/framework/react/quick-start
 */
import { QueryClient } from '@tanstack/react-query'

/**
 * QueryClientインスタンス
 * @description アプリケーション全体で共有するQueryClient
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      /**
       * データの鮮度時間（ミリ秒）
       * @description この時間内はデータを新鮮とみなし、refetchしない
       * @default 5分
       */
      staleTime: 1000 * 60 * 5,

      /**
       * キャッシュ保持時間（ミリ秒）
       * @description 非アクティブなクエリがキャッシュから削除されるまでの時間
       * @default 10分
       */
      gcTime: 1000 * 60 * 10,

      /**
       * ウィンドウフォーカス時のrefetch
       * @description ユーザーがタブに戻った時に自動refetchするか
       * @default false（モバイル対応のため）
       */
      refetchOnWindowFocus: false,

      /**
       * リトライ回数
       * @description クエリ失敗時のリトライ回数
       * @default 1回
       */
      retry: 1,

      /**
       * リトライ遅延
       * @description リトライまでの待機時間（指数バックオフ）
       */
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      /**
       * ミューテーションのリトライ回数
       * @default 0（即座に失敗）
       */
      retry: 0,
    },
  },
})
